import {
  ColoredSelectOption,
  ResultsStatus,
  SelectOption,
  WithContent,
} from '@src/common/types';
import { ElementDefinition, ElementsDefinition } from 'cytoscape';

export const linkAnalysisId = 'linkAnalysis';

export interface LinkAnalysisResultsStore {
  resultStatus: ResultsStatus;
  graphElements: CytoscapeElements;
  graphDataQeJson: string;
  sourceNodeId: string;
  legend: ColoredSelectOption[];
  fpStateApplied: LaFilterPanelState;
  csvExportInProgress: boolean;
  searchFieldValue: string;
  qeHighlightedPaths: string;
}

export interface LinkAnalysisFilterPanelStore {
  nodeTypes: LaNodeType[];
  nodeOptions: SelectOption[];
  nodesSelected: string[];
  idTypeOptions: SelectOption[];
  idTypeSelected: string;
  idTypeValidationMsg: string;
  value: string;
  hop: string;
  maxIpConnections: string;
  valueValidationMsg: string;
  searchBtnEnabled: boolean;
  loading: boolean;
}

export interface LaNodeType {
  name: string;
  value: string;
  productCode: string;
}

export interface LaNodeTypeResponse {
  nodeTypes: LaNodeType[];
  nodeTypeSelectOptions: SelectOption[];
}

export interface LaFilters {
  idTypeSelectOptions: SelectOption[];
  nodeTypes: LaNodeType[];
  nodeTypeSelectOptions: SelectOption[];
}

export interface LaFilterPanelState {
  nodesValue: string[];
  idType: string;
  value: string;
  hop: string;
  maxIpConnections: string;
}

export interface LaEdgesRequest {
  idType: string;
  idValue: string;
  depth: string;
  nodeTypes: string[];
  maxConnectionsPerIp: number | null;
  limit: number;
}

export interface LaEdgeApiItem {
  id: string;
  depth: number;
  sourceNodeId: string;
  sourceNodeType: string;
  sourceNodeValue: string;
  targetNodeId: string;
  targetNodeType: string;
  targetNodeValue: string;
  firstAccessed: string;
  lastAccessed: string;
  countInception: 1;
}

export type LaCachedEdges = Promise<{
  edges: LaEdgeApiItem[];
  resultStatus: ResultsStatus;
  sourceNodeId: string;
}>;

export interface LaNodeApiItem {
  id: string;
  type: string;
  value: string;
  dataSource: string;
  firstAccessed: string;
  lastAccessed: string;
  ipState: string;
  ipCountry: string;
  ipIsp: string;
  isIpInEuropeanUnion: boolean;
}

export type LaEdgesResponse = {
  depth: string;
  limit: number;
  total: number;
  size: number;
} & WithContent<LaEdgeApiItem>;

export type LaNodesResponse = WithContent<LaNodeApiItem>;

export type LaFetchEdgesResponse = {
  resultStatus: ResultsStatus;
  sourceNodeId: string;
  edges: LaEdgeApiItem[];
};

export interface GraphEdge {
  id: string;
  depth: number;
  source: string;
  target: string;
}

export type GraphNode = LaNodeApiItem;

export interface GraphData {
  edges: GraphEdge[];
  nodes: GraphNode[];
  sourceNodeId: string;
}

export type CytoscapeElements =
  | ElementsDefinition
  | ElementDefinition[]
  | Promise<ElementsDefinition>
  | Promise<ElementDefinition[]>;

export interface CsvJson {
  Level: number;
  'Node A Type': string;
  'Node A Value': string;
  'Node B Type': string;
  'Node B Value': string;
}

export interface GraphHoverStore {
  nodeLabel: string;
  nodeValue: string;
  style: React.CSSProperties;
  clazz: string;
  copied: boolean;
}
